import useToggleStyle from 'hooks/useToggleStyle';
import { useAppContext } from 'providers/AppProvider';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import CookieConsentBanner from 'components/common/CookieConsentBanner';
import { initializeAnalytics, trackPageView } from 'helpers/analytics';

const App = () => {
  const { isStylesheetLoaded } = useToggleStyle();
  const { pathname } = useLocation();

  const {
    config: { theme }
  } = useAppContext();

  // Initialize analytics if user has previously consented
  useEffect(() => {
    initializeAnalytics();
  }, []);

  // Automatically scrolls to top and track page view whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageView(pathname);
  }, [pathname]);

  return (
    <HelmetProvider>
      {/* Fallback title for routes without their own Helmet (login, sign-up, 404), which would
          otherwise keep the title baked into the prerendered index.html they were served. */}
      <Helmet defaultTitle={process.env.REACT_APP_TITLE} />
      {!isStylesheetLoaded ? (
        <div
          style={{
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: theme === 'dark' ? '#000' : '#fff'
          }}
        />
      ) : (
        <>
          <Outlet />
          <CookieConsentBanner />
        </>
      )}
    </HelmetProvider>
  );
};

export default App;
